"use strict";

angular.module("customer")
.controller("InvoiceListController", function(
    $scope, $q, $stateParams, $state, gettextCatalog, InvoiceService, InvoiceStatusService, UserService, PaymentService,
    StateExtensionService, UnpaidInvoicesStatementPrintButtonService, IS_MOBILE_APP
) {
    var _this = this;
    var promises = [];
    $scope.canInvoice = false;
    $scope.showAvailableVendors = false;
    $scope.selectedVendor = null;
    $scope.tabIndexes = {
        toPay: 0,
        paid: 1,
    }
    $scope.tabFilterUrlParams = {}
    $scope.tabFilterDefaultParams = {}
    $scope.tabFilterDefaultParams[$scope.tabIndexes.toPay] = {
        status: InvoiceStatusService.tabIndexStatus[$scope.tabIndexes.toPay].join(","),
        payment_due_filter: 'all',
        payment_due_date_start: undefined,
        payment_due_date_end: undefined,
        invoice_date_start: undefined,
        invoice_date_end: undefined,
        ordering: "payment_due_date"
    }
    $scope.tabFilterDefaultParams[$scope.tabIndexes.paid] = {
        status: InvoiceStatusService.tabIndexStatus[$scope.tabIndexes.paid].join(","),
        payment_due_filter: undefined,
        payment_due_date_start: undefined,
        payment_due_date_end: undefined,
        invoice_date_start: undefined,
        invoice_date_end: undefined,
        ordering: "-invoice_date"
    }
    $scope.activeTab = $stateParams.tab ? parseInt($stateParams.tab) : $scope.tabIndexes.toPay;
    $scope.currentActiveTab = null;

    $scope.defaultUnpaidInvoicesStatementPrintFormat = UnpaidInvoicesStatementPrintButtonService.PDF_LETTER_FORMAT;
    if (IS_MOBILE_APP) {
        $scope.defaultUnpaidInvoicesStatementPrintFormat = UnpaidInvoicesStatementPrintButtonService.PDF_RECEIPT_FORMAT;
    }

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
            $scope.isUserCanPay = user.is_user_can_pay;

            if (user.info) {
                $scope.canInvoice = user.info.can_invoice && !!$scope.dedicatedVendorId;
            }
        }
    });

    this.getDisabledButtonPayHelpTipHtmlContent = function() {
        return gettextCatalog.getString("Your owner didn't grants you access to the payment feature.");
    };

    this.seeUnpaidInvoices = function() {
        if (!$scope.isUserCanPay) {
            return;
        }

        var params = {selectAll: true};
        if ($scope.selectedVendor && $scope.selectedVendor.unpaid_invoice_ids) {
            params = {selected: $scope.selectedVendor.unpaid_invoice_ids};
        }
        $state.go('payment', params);
    };

    this.updateView = function() {
        if ($scope.activeTab === $scope.currentActiveTab) {
            return;
        }
        $scope.currentActiveTab = $scope.activeTab;
        StateExtensionService.updateUrlParams($scope.tabFilterUrlParams[$scope.activeTab]);
        _this.resetListing($scope.selectedVendor);
    };

    this.resetListing = function(selectedVendor) {
        StateExtensionService.updateUrlParams({tab: $scope.activeTab});
        $scope.$broadcast("doResetListing", selectedVendor);
    };

    var promise = InvoiceService.getCustomerAvailableVendors().$promise.then(function onSuccess(data) {
        $scope.availableVendors = data;
        var vendorLength = $scope.availableVendors.length;
        if (vendorLength === 1) {
            $scope.selectedVendor = $scope.availableVendors[0];
            $scope.showFilterDue = $scope.selectedVendor.has_unpaid_invoice_with_due_date;
        }
        else if (vendorLength > 1) {
            $scope.showAvailableVendors = true;
            angular.forEach($scope.availableVendors, function(value) {
                if (value.has_unpaid_invoice_with_due_date) {
                    $scope.showFilterDue = true;
                }
            });
        }
        return $scope.selectedVendor;
    });
    promises.push(promise);


    var deferred = $q.defer();
    var unregisterInvoiceListingReady = $scope.$on('invoiceListingReady', function() {
        deferred.resolve(true);
        unregisterInvoiceListingReady();
    });
    promises.push(deferred.promise);

    $q.all(promises).then(function onSuccess() {
        $scope.tabFilterUrlParams = angular.copy($scope.tabFilterDefaultParams);
        var overrideParams = {
            "status": $scope.tabFilterDefaultParams[$scope.activeTab]["status"],
            "payment_due_date_start": $stateParams.payment_due_date_start || $scope.tabFilterDefaultParams[$scope.activeTab]["payment_due_date_start"],
            "payment_due_date_end": $stateParams.payment_due_date_end || $scope.tabFilterDefaultParams[$scope.activeTab]["payment_due_date_end"],
            "payment_due_filter": $stateParams.payment_due_filter || $scope.tabFilterDefaultParams[$scope.activeTab]["payment_due_filter"]
        }
        angular.extend($scope.tabFilterUrlParams[$scope.activeTab], overrideParams);
        _this.updateView();
    });

    $scope.$on("listingFilterUpdated", function(event, filters) {
        StateExtensionService.updateUrlParams(filters);
        if (filters.clear || !filters.status) {
            StateExtensionService.updateUrlParams($scope.tabFilterDefaultParams[$scope.activeTab]);
        } else {
            StateExtensionService.updateUrlParams({payment_due_filter: 'custom'});
        }
        _this.resetListing($scope.selectedVendor);
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/invoice/invoice-list.controller.js
// module id = 911
// module chunks = 0